module.exports = __webpack_public_path__ + "static/img/index-desc-2.ea271d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index-desc-2.png
// module id = lweE
// module chunks = 1